import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-code-plus-icon',
  templateUrl: './code-plus.component.html'
})
export class CodePlusComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
